export default __webpack_public_path__ + "static/media/IMG_6244.4dd7ca06.jpg";